import { call, put, takeEvery } from "redux-saga/effects";
import { ADD_RISK_ASSESSMENT_FILE, DELETE_RISK_ASSESSMENT_FILE, GET_RISK_ASSESSMENT_LIST, UPDATE_STATUS } from "./actionTypes";
import {
  addRiskAssessmentFileFail,
  addRiskAssessmentFileSuccess,
  deleteRiskAssessmentListFail,
  deleteRiskAssessmentListSuccess,
  getRiskAssessmentListFail,
  getRiskAssessmentListSuccess,
} from "./actions";
import { onAddingRiskAssessment, onGettingRiskAssessmentList, onDeletingRiskAssessment, onUpdatingRiskAssessment } from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { updateRiskAssessmentStatusSuccess } from "./actions";
import { updateRiskAssessmentStatusFail } from "./actions";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Risk Assessment";

function* onGet({ payload: data }) {
  try {
    const response = yield call(onGettingRiskAssessmentList, data);
    yield put(getRiskAssessmentListSuccess(response));
  } catch (error) {
    yield put(getRiskAssessmentListFail(error));
    showToast("error", "Risk Assessment", error);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingRiskAssessment, data);
    yield call(responseHandler, toastTitle, response, addRiskAssessmentFileSuccess, addRiskAssessmentFileFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addRiskAssessmentFileFail(error));
    showToast("error", "Risk Assessment", error);
  }
}

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingRiskAssessment, data);
    yield call(responseHandler, toastTitle, response, deleteRiskAssessmentListSuccess, deleteRiskAssessmentListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteRiskAssessmentListFail(error));
    showToast("error", "Risk Assessment", error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingRiskAssessment, data);
    yield call(responseHandler, toastTitle, response, updateRiskAssessmentStatusSuccess, updateRiskAssessmentStatusFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateRiskAssessmentStatusFail(error));
    showToast("error", "Risk Assessment", error);
  }
}

function* RiskAssessmentSaga() {
  yield takeEvery(GET_RISK_ASSESSMENT_LIST, onGet);
  yield takeEvery(ADD_RISK_ASSESSMENT_FILE, onAdd);
  yield takeEvery(DELETE_RISK_ASSESSMENT_FILE, onDelete);
  yield takeEvery(UPDATE_STATUS, onUpdate);
}

export default RiskAssessmentSaga;
